import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
// import OrganizationForm from '@App/components/forms/OrganizationForm'
import { Trans } from 'react-i18next'
import {
  IOrganizationFormProps,
  OrganizationFormMode,
} from '@App/components/forms/OrganizationForm/types'
import {
  ORGANIZATION_EDITING,
  ORGANIZATION_CREATION,
} from '@App/constantes'

class OrganizationFormPage extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      mode: this.props.editing ? OrganizationFormMode.UPDATE : OrganizationFormMode.CREATE,
    }
  }

  render() {
    const { editing } = this.props
    const { mode } = this.state

    const organizationFormProps: IOrganizationFormProps = {
      mode: mode as OrganizationFormMode,
    }

    const section = mode === OrganizationFormMode.UPDATE ?
      <Trans i18nKey={ORGANIZATION_EDITING} values={{ name: editing.name }} /> :
      <Trans i18nKey={ORGANIZATION_CREATION} />

    return (
      <React.Fragment>
        <section className="section">
          <h1 className="section-title">{section}</h1>
          {/* <OrganizationForm { ...organizationFormProps } /> */}
        </section>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state: any) => {
  const {
    organizations: {
      editing,
    },
  } = state

  return {
    editing,
  }
}

export default compose(
  connect(mapStateToProps),
)(OrganizationFormPage)
